"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addBorderClasses = addBorderClasses;
exports.borderPropTypes = void 0;
exports.getBorder = getBorder;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
/*
utils to handle common logic related to adding borders to components via PropTypes
*/

function generateBorderPropTypes() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$denylist = _ref.denylist,
    denylist = _ref$denylist === void 0 ? [] : _ref$denylist;
  var shape = {
    top: _propTypes["default"].bool,
    right: _propTypes["default"].bool,
    bottom: _propTypes["default"].bool,
    left: _propTypes["default"].bool
  };
  denylist.forEach(function (k) {
    delete shape[k];
  });
  return _propTypes["default"].shape(shape);
}
var borderPropTypes = generateBorderPropTypes();

/**
 * Given the spacing props, returns an array of CSS classes to apply the padding/margin
 * @param {object} settings The margin or padding props
 * @returns {array} array of CSS classes
 */
exports.borderPropTypes = borderPropTypes;
function getBorder(settings) {
  var finalSettings = (0, _extends2["default"])({}, settings);
  if (!finalSettings) return null;
  var settingsArray = Object.keys(finalSettings);
  if (settingsArray.length === 0) return null;
  var sidemap = {
    top: 't',
    left: 'l',
    right: 'r',
    bottom: 'b'
  };
  return settingsArray.map(function (side) {
    return "st_border--".concat(sidemap[side]);
  });
}

/**
 * Given an object with props from user, returns a new object that removes
 * all properties that are disallowed
 *
 * @param {object} settings the border props provided to component
 * @param {array} denylist array of strings with name of disallowed props
 */
function sanitizeProps(settings) {
  var denylist = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newSettings = (0, _extends2["default"])({}, settings);
  Object.keys(settings).forEach(function (k) {
    if (denylist.includes(k)) delete newSettings[k];
  });
  return newSettings;
}

/*
given array of original css class arrays
and margin PropTypes
return new array with margin classes, or the original aray
*/
function addBorderClasses(border) {
  var cssClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var denylist = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  if (!border || Object.keys(border).length === 0) return cssClasses;
  return (cssClasses || []).concat(getBorder(sanitizeProps(border, denylist) || []));
}